import script from "./DataGroupInviteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataGroupInviteModal.vue?vue&type=script&setup=true&lang=ts"

import "./DataGroupInviteModal.vue?vue&type=style&index=0&id=985d34a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-985d34a8"]])

export default __exports__